// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xXS1x","col":"styles_col__3jxT5","actions":"styles_actions__3Fms6","conflict":"styles_conflict__XJGdd"};